<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="账户信息" name="0">
                <div class="accountInfo">
                    <div class="acctitle flx alc jsb" style="margin-bottom: 10px;">
                        <div class="actleft">
                            数据看板
                        </div>
                        <div class="acRight flx alc" :style="info.level == 2?'visibility:hidden' : ''">
                            <div class="acrtips">
                                为了不影响您活动报名、提现和管理，请及时认证
                            </div>
                            <el-button type="primary" @click="toConfirm">立即认证</el-button>
                        </div>
                    </div>
                    <div class="accountItems flx alc jsb">
                        <div class="accLeft flx alc">
                            <div class="accItem">
                                <div class="accTitles">
                                    活动累计收入(元)
                                </div>
                                <div class="accNum">
                                    0
                                </div>
                                <div class="accBtn flx alc">
                                    <div class="accName">
                                        账单明细
                                    </div>
                                    <i class="el-icon-arrow-right"
                                        style="font-size: 14px;color:#007AFF;font-weight: bold;"></i>
                                </div>
                            </div>
                            <div class="accshu"></div>
                            <div class="accItem">
                                <div class="accTitles">
                                    可提现金额(元)
                                </div>
                                <div class="accNum">
                                    0
                                </div>
                                <div class="accBtn">
                                    <div class="accName">账单明细</div>  
                                    <i class="el-icon-arrow-right"
                                        style="font-size: 14px;color:#007AFF;font-weight: bold;"></i>
                                </div>
                            </div>
                        </div>

                        <div class="accLeft flx alc">
                            <div class="accItem">
                                <div class="accTitles">
                                    短信累计消费(元)
                                </div>
                                <div class="accNum">
                                    0
                                </div>
                                <div class="accBtn flx alc">
                                    <div class="accName">
                                        账单明细
                                    </div>
                                    <i class="el-icon-arrow-right"
                                        style="font-size: 14px;color:#007AFF;font-weight: bold;"></i>
                                </div>
                            </div>
                            <div class="accshu"></div>
                            <div class="accItem">
                                <div class="accTitles">
                                    短信余额(元)
                                </div>
                                <div class="accNum">
                                    0
                                </div>
                                <div class="accBtn">
                                    <div class="accName">充值</div>  
                                    <i class="el-icon-arrow-right"
                                        style="font-size: 14px;color:#007AFF;font-weight: bold;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="acctitle flx alc jsb" style="margin: 20px 0 30px;">
                        <div class="actleft">
                            财务信息
                        </div>
                    </div>
                    <div class="acc flx alc">
                        <div class="accItem" style="padding-left: 70px;">
                            <div class="accTitles">
                                收入总额(元)
                            </div>
                            <div class="accNum">
                                0
                            </div>
                            <div class="accBtn flx alc">
                                <div class="accName">
                                    账单明细
                                </div>
                                <i class="el-icon-arrow-right"
                                    style="font-size: 14px;color:#007AFF;font-weight: bold;"></i>
                            </div>
                        </div>
                        <div class="accItem" style="padding-left: 70px;">
                            <div class="accTitles">
                                可提现(元)
                            </div>
                            <div class="accNum">
                                0
                            </div>
                            <div class="accBtn flx alc">
                                <div class="accName">
                                    去提现
                                </div>
                                <i class="el-icon-arrow-right"
                                    style="font-size: 14px;color:#007AFF;font-weight: bold;"></i>
                            </div>
                        </div>
                        <div class="accItem" style="padding-left: 70px;">
                            <div class="accTitles">
                                待结算(元)
                            </div>
                            <div class="accNum">
                                0
                            </div>
                            <div class="accBtn flx alc">
                                <div class="accName">
                                    账单明细
                                </div>
                                <i class="el-icon-arrow-right"
                                    style="font-size: 14px;color:#007AFF;font-weight: bold;"></i>
                            </div>
                        </div>
                        <div class="accItem" style="padding-left: 70px;">
                            <div class="accTitles">
                                已提现(元)
                            </div>
                            <div class="accNum">
                                0
                            </div>
                            <div class="accBtn flx alc">
                                <div class="accName">
                                    账单明细
                                </div>
                                <i class="el-icon-arrow-right"
                                    style="font-size: 14px;color:#007AFF;font-weight: bold;"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="活动订单" name="1"></el-tab-pane>
            <el-tab-pane label="账户金额" name="2"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {
        shoUserInfo
    } from "@/api/index.js"
    export default {
        name: 'Shops',
        data() {
            return {
                activeName: '0',
                info: {
                    level:2
                }
            };
        },
        created() {
            this.getUserinfo()
        },
        methods: {
            getUserinfo() {
                let that = this
                shoUserInfo().then((res) => {
                    console.log("333", res)
                    if (res.code == 1) {
                        that.info = res.data
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            },
            handleClick(tab) {
                console.log(tab);
            },
            toConfirm() {
                this.$emit('toConfirm', '去认证')
            }
        }
    }
</script>

<style>
    .acc{
        width: 100%;
        height: 165px;
        background: #F9F9F9;
        border-radius: 6px;
    }
    .accBtn {
        box-sizing: border-box;
        padding: 5px 11px;
        border-radius: 2px;
        border: 1px solid #007AFF;
        display: inline-block;
    }
    
    .accshu{
        width: 1px;
        height: 50px;
        background: #D9D9D9;
    }

    .accName {
        font-size: 12px;
        color: #007AFF;
        margin-right: 4px;
        float: left;
    }

    .accTitles {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 10px;
        text-align: left;
    }

    .accNum {
        font-weight: 600;
        font-size: 26px;
        line-height: 36px;
        text-align: left;
        margin-bottom: 10px;
    }

    .accItem {
        box-sizing: border-box;
        padding: 30px 32px;
        width: 50%;
        text-align: left;
        /* flex: 1; */
    }

    .accLeft {
        width: 451px;
        height: 165px;
        background: #F9F9F9;
        border-radius: 6px;
    }
/* 
    .accItem {
        flex: 1;
    } */

    .acrtips {
        font-weight: 500;
        font-size: 14px;
        color: #FF0F23;
        margin-right: 25px;
    }

    .actleft {
        font-weight: 600;
        font-size: 16px;
    }

    .el-tabs__nav-scroll {
        box-sizing: border-box;
        padding: 20px 30px 0;
    }

    .accountInfo {
        box-sizing: border-box;
        padding: 3px 30px 32px;
    }
</style>